<template>
  <section>
    <div class="container">
      <ul class="breadcrumb">
        <li v-for="crumb in breadcrumbs"
            :class="{active:crumb.active}">
          <span v-if="crumb.active"
                v-html="crumb.name">
          </span>
          <a v-else
             :href="crumb.seo_link"
             v-html="crumb.name">
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "breadcrumbs",
    computed:{
        ...mapState({
            breadcrumbs: state => state.persistent.currentNav,
        })
    },
    updated() {
        this.$emit('updateHead');
    },
    head: {
        script() {
            if (!this.breadcrumbs.length) {
                return [];
            }
            return [{
                id: 'breadcrumb-schema',
                type: 'application/ld+json',
                inner: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    numberOfItems: this.breadcrumbs.length,
                    itemListElement: this.breadcrumbs.map((crumb, i) => {
                        return {
                            '@type': 'ListItem',
                            position: i + 1,
                            item: {
                                '@id': window.location.origin + crumb.seo_link,
                                name: crumb.name,
                            }
                        };
                    }),
                })
            }];
        }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/breadcrumbs.vue